import { environment } from 'src/environments/environment';

export const firebaseConfig = environment.firebaseConfig;
